import { promise } from './util';

export default ({ web3, config, timer, serviceFactory }) => {

  const interval = config.accountService.interval || 500;

  var current;
  var ts;
  return serviceFactory({
    name: 'account-service',
    subscribe: (update) => {
      if (Date.now() - ts < interval) {
        update({ account: current });
      }
      current = null;
      timer.periodic('account-service', interval,
        () => web3
        .then(w3 => promise(cb => w3.eth.getAccounts(cb)))
        .then(accts => {
          const acct = accts[0];
          if (acct !== current) {
            current = acct;
            ts = Date.now();
            update({ account: acct })
          }
        })
      )
    }
  });
}


// WEBPACK FOOTER //
// ./src/api/account-service.js